
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { AgentResource,
  AgentDeliveryForResource,
  AgentFacilityResource,
  AgentManufacturerResource,
  AgentCompanyResource,
  AgentCommodityResource,
  AgentReferenceTypeResource,
  AgentAccessorialChargeTypeResource,
  AgentSettingResource } from "../../models/api/system/agents";
import { ReasonCodeResource } from "../../models/api/system/reasonCodes";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import router from "@/router";
import { AgentFacilityResourceSelect} from "../../models/ui/manageAgent";
import ManageDeliveryFors from "../../components/agent/manage/ManageDeliveryFors.vue";
import ManageFacilities from "../../components/agent/manage/ManageFacilities.vue";
import ManageManufacturers from "../../components/agent/manage/ManageManufacturers.vue";
import ManageBillToCompanies from "../../components/agent/manage/ManageBillToCompanies.vue";
import ManageReferenceTypes from "../../components/agent/manage/ManageReferenceTypes.vue";
import ManageCommodities from "../../components/agent/manage/ManageCommodities.vue";
import ManageAccessorialCharges from "../../components/agent/manage/ManageAccessorialCharges.vue";
import ManageSettings from "../../components/agent/manage/ManageSettings.vue";
import UsersTab from "../../components/agent/UsersTab.vue";
import ManageDeliveryTypes from "../../components/agent/manage/ManageDeliveryTypes.vue";

const systemModule = getModule(SystemModule);

interface AgentManufacturerResourceSelect {
  manufacturer: AgentManufacturerResource,
  isSelected: boolean
}

@Component({
  components: {
    ManageDeliveryFors,
    ManageFacilities,
    ManageManufacturers,
    ManageBillToCompanies,
    ManageReferenceTypes,
    ManageCommodities,
    ManageAccessorialCharges,
    ManageSettings,
    UsersTab,
    ManageDeliveryTypes
  }
})
export default class AgentEdit extends Vue {
  loading: boolean = false;
  loadingPage: boolean = false;

  agentId: number|null;

  agent: AgentResource = {
    id: null,
    name: null,
    isActive: true
  };


  agentDeliveryFors: AgentDeliveryForResource[] = [];
  agentFacilities: AgentFacilityResource[] = [];
  agentManufacturers: AgentManufacturerResource[] = [];
  agentCompanies: AgentCompanyResource[] = [];
  agentCommodities: AgentCommodityResource[] = [];
  agentReferenceTypes : AgentReferenceTypeResource[] = [];
  agentAccessorialChargeTypes: AgentAccessorialChargeTypeResource[] = [];
  agentSettings: AgentSettingResource[] = [];
  agentCompanyManufacturers: AgentManufacturerResourceSelect[] = [];
  agentCompanyFacilities: AgentFacilityResourceSelect[] = [];
  agentCompanyReasonCodes: ReasonCodeResource[] = [];

  async loadAgentDeliveryFors() {
    if (this.agentId !== null) {
      this.agentDeliveryFors = await systemModule.getAgentDeliveryFors(this.agentId);
    }
  }

  async loadAgentFacilities() {
    if (this.agentId !== null) {
      this.agentFacilities = await systemModule.getAgentFacilities(this.agentId);
    }
  }

  async loadAgentCommodities() {
    if (this.agentId !== null) {
      this.agentCommodities = await systemModule.getAgentCommodities(this.agentId);
    }
  }

  async loadAgentAccessorialChargeTypes() {
    if (this.agentId !== null) {
      this.agentAccessorialChargeTypes = await systemModule.getAgentAccessorialChargeTypes(this.agentId);
    }
  }

  async loadAgentReferenceTypes() {
    if (this.agentId !== null) {
      this.agentReferenceTypes = await systemModule.getAgentReferenceTypes(this.agentId);
    }
  }

  async loadAgentSettings() {
    if (this.agentId !== null) {
      this.agentSettings = await systemModule.getAgentSettings(this.agentId);
    }
  }

  async loadAgentManufacturers() {
    if (this.agentId !== null) {
      this.agentManufacturers = await systemModule.getAgentManufacturers(this.agentId);
    }
  }

  async loadAgentBillToCompanies() {
    if (this.agentId !== null) {
      this.agentCompanies = await systemModule.getAgentCompanies(this.agentId);
    }
  }

  async created() {
    this.loadingPage = true;

    this.agentId = Number(this.$route.params.id);
    if (isNaN(this.agentId)) this.agentId = null;

    if (this.agentId !== null) {
      this.agent = await systemModule.getAgent(this.agentId);
      this.loadAgentBillToCompanies();
      this.loadAgentFacilities();
      this.loadAgentManufacturers();
      this.loadAgentDeliveryFors();
      this.loadAgentCommodities();
      this.loadAgentReferenceTypes();
      this.loadAgentAccessorialChargeTypes();
      this.loadAgentSettings();
    }

    this.loadingPage = false;
  }

  done() {
    router.push(`/admin/agents`);
  }
}
